<template>
  <div>
    <SupportProgramConsumers v-if="type ==='support'" :program="program" />
    <LoyaltyCardProgramConsumers v-if="type ==='loyalty-card'" :program="program" />
    <FeatureProgramConsumers v-if="type ==='feature'" :program="program" />
  </div>
</template>

<script lang="ts" setup>
import {computed} from "vue";
import {Program} from "@/program/interfaces/Program";
import SupportProgramConsumers from "@/program/components/program-consumers/SupportProgramConsumers.vue";
import LoyaltyCardProgramConsumers from "@/program/components/program-consumers/LoyaltyCardProgramConsumers.vue";
import FeatureProgramConsumers from "@/program/components/program-consumers/FeatureProgramConsumers.vue";

const props = defineProps<{
    program: Program
}>();

const type = computed(() => props.program.programmable_type);
</script>
